// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "大学英语（一）",
        "tec": "苏欣",
        "week": "6-9,11-18周",
        "add": "教学楼D座215经管"
      },
      {
        "sub": "26动管2-2",
        "tec": "丁璐瑶",
        "week": "6-9,11-18周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "26动管1-1",
        "tec": "张然",
        "week": "6-9,11-18周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26动管1-4",
        "tec": "刘亚梅",
        "week": "6-9,11-18周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "26动管1-3",
        "tec": "单韧",
        "week": "6-9,11-18周",
        "add": "教学楼B座319能动"
      },
      {
        "sub": "26动管2-4",
        "tec": "王晓红",
        "week": "6-9,11-18周",
        "add": "教学楼B座221自控"
      },
      {
        "sub": "26动管1-2",
        "tec": "杨丹丹",
        "week": "6-9,11-18周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "26动管2-3",
        "tec": "徐常翠",
        "week": "6-9,11-18周",
        "add": "教学楼B座218自控"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[03-04节]）"
    },
    {
      "sub": "微积分（一）",
      "tec": "陆歆怡",
      "week": "6-17周",
      "add": "教学楼D座326文法"
    },
    {
      "sub": "军事理论",
      "tec": "王倩",
      "week": "6-14周",
      "add": "教学楼D座213经管"
    },
    0
  ],
  "2": [
    0,
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "郭冰莹",
        "week": "6,8,10,12,14,16周",
        "add": "实训楼C座308"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "郭冰莹",
        "week": "7,9,11,13,17周",
        "add": "教学楼A座118电力"
      }
    ],
    0,
    {
      "sub": "工业工程导论",
      "tec": "刘捷",
      "week": "6-14,16-18周",
      "add": "教学楼D座221经管"
    },
    0
  ],
  "3": [
    {
      "sub": "微积分（一）",
      "tec": "陆歆怡",
      "week": "6-17周",
      "add": "教学楼D座326文法"
    },
    {
      "sub": "管理学",
      "tec": "李镜",
      "week": "6-14,16-18周",
      "add": "教学楼D座223经管"
    },
    0,
    {
      "sub": "健康教育",
      "tec": "谢雨彤",
      "week": "6-17周",
      "add": "教学楼C座308教务"
    },
    0
  ],
  "4": [
    0,
    [
      {
        "sub": "大学英语（一）",
        "tec": "苏欣",
        "week": "6-9,11-18周",
        "add": "实训楼E座310"
      },
      {
        "sub": "26动管2-2",
        "tec": "丁璐瑶",
        "week": "6-9,11-18周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "26动管1-1",
        "tec": "刘亚梅",
        "week": "6-9,11-18周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "26动管1-3",
        "tec": "张然",
        "week": "6-9,11-18周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "26动管1-4",
        "tec": "单韧",
        "week": "6-9,11-18周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "26动管2-4",
        "tec": "徐常翠",
        "week": "6-9,11-18周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "26动管2-1",
        "tec": "杨丹丹",
        "week": "6-9,11-18周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26动管2-3",
        "tec": "王晓红",
        "week": "6-9,11-18周",
        "add": "实训楼E座503语音室"
      }
    ],
    0,
    {
      "sub": "形势与政策",
      "tec": "张文东",
      "week": "6-9周",
      "add": "教学楼C座311教务"
    },
    0
  ],
  "5": [
    {
      "sub": "就业创业指导",
      "tec": "马彤兵",
      "week": "9-13周",
      "add": "教学楼D座222经管"
    },
    {
      "sub": "管理学",
      "tec": "李镜",
      "week": "6-14,16-18周",
      "add": "教学楼D座224经管"
    },
    {
      "sub": "人工智能与计算思维",
      "tec": "郭冰莹",
      "week": "7,9,11,13,17周",
      "add": "教学楼D座323文法"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
